import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IGameAssignmentContext, GameAssignmentContext } from '../../../../gameAssignmentState/gameAssignmentContext';
import Game from './components/Game';
import style from './Games.module.scss';

const Games: React.FC = () => {
	const { gamesForAssign } = useContext<IGameAssignmentContext>(GameAssignmentContext);

	return (
		<div className={style.container} data-test="Games">
			<div className={style.tableOfContents}>
				<Text translationNameSpace="listing" translationKey="nameLabel" theme="neutralLight" />
			</div>
			{gamesForAssign.games.map((el) => (
				<Game data={el} key={el.id + 'gameList'} />
			))}
		</div>
	);
};

export default Games;
